<template>
    <div class="register">

        <div class="container-fluid">

            <div class="w-100 mt-7 mb-8 d-flex">
                <img src="/images/card/logo.svg" class="logo mb-0 mt-0">

                <div class="ms-7 d-flex align-items-center pt-1">
                    <h2 class="text-dark mb-0" style="line-height: 1.1;">{{ company_name }}</h2>
                </div>
            </div>

        </div>

        <transition name="fade" mode="in-out">

            <div v-if="success">

                <div class="container-fluid">

                    <div class="w-100 text-center">

                        <picture class="mb-6" style="width:600px; max-width: 100%;">
                          <source srcset="/images/card/register-success.webp" type="image/webp">
                          <source srcset="/images/card/register-success.png" type="image/png"> 
                          <img src="/images/card/register-success.png" class="mb-6" style="width:600px; max-width: 100%;">
                        </picture>

                        <h1>Ditt konto har skapats!</h1>
                        <p>Scanna QR-koden med kameran i din mobil för att komma igång.<br>
                        Du får också inom kort ett SMS där länken finns.</p>

                    </div>

                </div>

            </div>

            <div v-if="!success && fetcher.initialized">

                <div class="cover-image mb-8 mb-md-12">
                    <img :src="'/storage/open-registration-images/'+open_registration_image" v-if="open_registration_image">

                    <picture v-if="!open_registration_image">
                      <source srcset="/images/card/register-cover-default.webp" type="image/webp">
                      <source srcset="/images/card/register-cover-default.jpg" type="image/jpg"> 
                      <img src="/images/card/register-cover-default.jpg">
                    </picture>

                </div>

                <div class="container-fluid">

                    <div class="row pb-8 pb-md-12">

                        <div class="col-24 col-md-12 mb-8 mb-md-0">
                            <h1>{{ open_registration_title }}</h1>
                            <div style="white-space: pre-wrap;" class="pe-md-6 pe-lg-8">{{ open_registration_text }}</div>
                        </div>

                        <div class="col-24 col-md-12">
                            <h2>Skapa konto</h2>
                            <p class="d-none d-md-block mb-8">När kontot är skapat får du en länk per SMS för att installera din bokningsapp och komma igång.</p>

                            <form @submit.prevent="posterPost()">

                                <div class="form-group mb-5" :key="field.id" v-for="field in dynamic_fields">
                                    <input-text
                                        :type="field.input_type"
                                        :name="'dynamic_fields_data.'+field.id+'.value'"
                                        :label="field.label"
                                        :required="field.is_required"
                                        v-model="dynamic_fields_data[field.id].value"
                                        v-if="field.type !== 'workplace_id'"
                                        :float-label="true"
                                    />
                                    <input-select
                                        :name="'dynamic_fields_data.'+field.id+'.value'"
                                        :label="field.label"
                                        :required="field.is_required"
                                        v-model="dynamic_fields_data[field.id].value"
                                        :options="workplaces"
                                        v-if="field.type === 'workplace_id'"
                                        :float-label="true"
                                    />
                                </div>

                                <div class="mt-3 mb-4 text-end">
                                    Genom att skapa kontot godkänner du Hälsoresurs <a href="https://halsoresurs.se/integritetspolicy/" target="_blank">integritetspolicy</a>
                                </div>

                                <div class="d-flex justify-content-end">
                                    <button type="submit" class="btn btn-primary" :disabled="poster.submitted">
                                        Skapa konto
                                    </button>
                                </div>

                            </form>

                        </div>

                    </div>

                </div>

            </div>

        </transition>

    </div>

</template>

<script>

import fetcher from '../../../../shared/mixins/fetcher'
import poster from '../../../../shared/mixins/poster'
import employeeDynamicFields from '../../../../shared/mixins/employee-dynamic-fields'

export default {

    mixins: [
        fetcher,
        poster,
        employeeDynamicFields
    ],

    data () {
        return {
            employee: {
                dynamic_fields: []
            },
            workplaces: [],
            company_id: null,
            company_name: null,
            open_registration_image: null,
            open_registration_token: null,
            open_registration_title: null,
            open_registration_text: null,
            dynamic_fields: [],
            fetcher: {
                autoFill: [
                    'workplaces',
                    'company_id',
                    'company_name',
                    'open_registration_image',
                    'open_registration_token',
                    'open_registration_title',
                    'open_registration_text',
                    'dynamic_fields'
                ]
            },
            success: false
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/' + this.$route.params.token + '/' + this.$route.params.slug
        },
        posterUrl () {
            return '/data/register/' + this.company_id
        },
        posterData () {
            return {
                dynamic_fields_data: this.dynamic_fields_data,
                token: this.$route.params.token
            }
        }
    },

    methods: {

        fetcherSuccess () {
            this.resetDynamicFieldData()
        },

        posterSuccess () {
            if (window.innerWidth < 576) {
                window.location = '/login?registered=1'
            } else {
                this.success = true
            }
        }
    }

}
</script>
<style type="text/css">

    /* --- Fade transition --- */
    .fade-enter-active, .fade-leave-active {
      transition: all 250ms;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

</style>
